window.select_char = promokit.select({
    el: '#select-char',
    placeholder:'1. 캐릭터를 선택해주세요.'
});

window.select_role = promokit.select({
    el: '#select-role',
    options: [
        {label: '파티장', value:1},
        {label: '파티원', value:2}
    ],
    placeholder:'2. 파티장/파티원 여부를 선택해주세요.',
    disabled: true
});

window.select_member = promokit.select({
    el: '#select-member',
    placeholder:'파티를 맺을 캐릭터 선택 후 수락 버튼을 눌러주세요.'
});

$(document).on('click', '.p-btn__acc--login', function(){
    promokit.login();
});

let layer = promokit.layer({
    el:'#layer-1',
    buttons:'.open-1',
    render:true
});

let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        home:true,
        event:true,
        update:false,
        sns:true,
        theme:'black'
    },
    caution:{
        template:
        `<ol>
            <li>제재된 계정은 이벤트 참여가 불가합니다.</li>
            <li>한번 선택한 캐릭터와 파티장/파티원은 변경이 불가능합니다.</li>
            <li>파티장이 발급하는 초대장 코드는 최대 30명이 입력할 수 있으며, 파티원은 최대 5회까지만 파티 지원이 가능합니다.</li>
            <li>파티 지원 후 파티 수락으로 파티를 맺은 뒤 취소가 불가능합니다.</li>
            <li>동일 명의 계정으로 파티 맺기가 불가능합니다.</li>
            <li>용계 미션은 6명의 파티원이 모두 인게임에서 파티를 맺은 후 인던 입장, 몬스터 공략을 해야 미션이 완료됩니다.</li>
            <li>추가 용계 미션 완료 후 지급된 쿠폰은 발급 후 30일 이내 사용 가능하며, 기간이 지난 쿠폰은 사용할 수 없습니다.</li>
            <li>이벤트로 획득한 모든 아이템은 거래 및 판매대행이 불가능합니다.</li>
            <li>용계 고정 파티 인증 이벤트 참여 말머리를 적용하지 않은 경우 참여 대상에서 제외됩니다.</li>
            <li>모든 보상은 기프티쇼 모바일 쿠폰으로 지급되며 상품 지급을 위한 개인정보 수집 및 활용 동의가 필요할 수 있습니다.</li>
        </ol>`
    }
});

$(document).on('click','.p-select__my--char a',function () {
    $('.p-select__my').removeClass('active').removeClass('disabled');
    $('.p-select__my--role').addClass('active');
    $('.p-btn__mychar').addClass('disabled');
    select_role.update({
        selected:-1,
        disabled:false
    });
});
$(document).on('click','.p-select__my--role a',function () {
    $('.p-select__my--role').removeClass('active');
    $('.p-btn__mychar').removeClass('disabled');
});

promokit.layer({
    el: '#p-layer',
    buttons: '.p-btn__detail'
});

$(document).on('click','.p-btn__invite--copy',function () {
    var $mycode = $('.p-invite__code')[0].innerHTML;
    if(!($mycode === '')){
        var aux = document.createElement("input");
        aux.setAttribute("value", $mycode);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        promokit.message({
            type: 'alert',
            message: '초대장 코드가 발급되었습니다.'
        });
    }
});

let _components = {
    '.p-mission__item--1>a' : {
        linkUrl:'https://aion.plaync.com/guidebook/classic/view?title=%EB%B2%84%EB%A0%A4%EC%A7%84%20%EC%9A%B0%EB%8B%A4%EC%8A%A4%20%EC%8B%A0%EC%A0%84',
    },
    '.p-mission__item--2>a' : {
        linkUrl:'https://aion.plaync.com/guidebook/classic/view?title=%EC%9A%B0%EB%8B%A4%EC%8A%A4%20%EC%8B%A0%EC%A0%84%20%EC%A7%80%ED%95%98',
    },
    '.p-mission__item--3>a' : {
        linkUrl:'https://aion.plaync.com/guidebook/classic/view?title=%ED%8C%8C%EC%8A%88%EB%A7%8C%EB%94%94%EB%A5%B4%20%EC%82%AC%EC%9B%90',
    },
    '.p-mission__item--4>a' : {
        linkUrl:'https://aion.plaync.com/guidebook/classic/view?title=%ED%8C%8C%EC%8A%88%EB%A7%8C%EB%94%94%EB%A5%B4%20%EC%82%AC%EC%9B%90',
    },
};

$.each(_components, function (key, value) {
    $(key).attr('href', value.linkUrl);
});


// WEBPACK FOOTER //
// ./src/js/index.js